import type { AppContext } from '@client/modules/app-context';
import { withAppContext } from '@client/modules/app-context/react';
import React from 'react';
import { PageNotFoundRedirect } from './PageNotFoundRedirect';

const RouteNotFoundComponent: React.FunctionComponent<{ appContext: AppContext }> = () => <PageNotFoundRedirect />;

export const RouteNotFoundContainer: React.ComponentType = withAppContext(RouteNotFoundComponent);
